export var CreatedByType;
(function (CreatedByType) {
    CreatedByType["Admin"] = "Admin";
    CreatedByType["Adviser"] = "Adviser";
    CreatedByType["Investor"] = "Investor";
})(CreatedByType || (CreatedByType = {}));
//# sourceMappingURL=api.js.map